/**
 * Admin Dates application list ordering and age labels.
 * @see docs/APP_UI_SPEC.md — C1
 */

/**
 * @param {{ comedian_name?: string|null, email?: string|null, id?: string|number }} a
 * @param {{ comedian_name?: string|null, email?: string|null, id?: string|number }} b
 */
export function compareApplicationsAlphabetically(a, b) {
  const nameA = String(a?.comedian_name || '').trim().toLowerCase();
  const nameB = String(b?.comedian_name || '').trim().toLowerCase();
  if (nameA !== nameB) return nameA.localeCompare(nameB);

  const emailA = String(a?.email || '').trim().toLowerCase();
  const emailB = String(b?.email || '').trim().toLowerCase();
  if (emailA !== emailB) return emailA.localeCompare(emailB);

  return String(a?.id ?? '').localeCompare(String(b?.id ?? ''), undefined, { numeric: true });
}

/**
 * @param {Array<object>|null|undefined} applications
 * @returns {Array<object>}
 */
export function sortApplicationsAlphabetically(applications) {
  return [...(applications || [])].sort(compareApplicationsAlphabetically);
}

/**
 * @param {string|Date|null|undefined} createdAt
 * @param {Date} [now]
 * @param {{ unknownLabel?: string|null }} [opts] - set unknownLabel null to hide when date missing
 * @returns {string} e.g. "Applied 3 days ago"
 */
export function formatApplicationAgeLabel(createdAt, now = new Date(), opts = {}) {
  const unknownLabel = opts.unknownLabel === undefined ? 'Applied (date unknown)' : opts.unknownLabel;
  if (createdAt == null || createdAt === '') {
    return unknownLabel || '';
  }

  const created = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(created.getTime())) {
    return unknownLabel || '';
  }

  const startOfNow = new Date(now);
  startOfNow.setHours(0, 0, 0, 0);
  const startOfCreated = new Date(created);
  startOfCreated.setHours(0, 0, 0, 0);

  const dayMs = 86400000;
  const days = Math.floor((startOfNow - startOfCreated) / dayMs);

  if (days <= 0) return 'Applied today';
  if (days === 1) return 'Applied 1 day ago';
  if (days < 14) return `Applied ${days} days ago`;

  const weeks = Math.floor(days / 7);
  if (weeks === 1) return 'Applied 1 week ago';
  return `Applied ${weeks} weeks ago`;
}
